import { DateTime } from 'luxon';

export function getSelectedDates(startDate, endDate) {
  var _selected_dates = [];
  var i = startDate;
  if (isNaN(endDate) || typeof endDate == "string") {
    endDate = startDate;
  }

  while (i <= endDate) {
    _selected_dates.push(i);
    if (new Date(i * 1000).getHours() == 23) {
      i += 86400;
      i += 3600;
    } else if (new Date(i * 1000).getHours() == 1) {
      i += 86400;
      i -= 3600;
    } else {
      i += 86400;
    }
  }
  return _selected_dates;
}


export function convert_date_to_timestamp(date) {

  if (date == null) {
    return '';
  }

  return new Date(date).setHours(0, 0, 0, 0) / 1000;
}

export function format_date(dateObject, type, endDateObject) {
  if (!is_valid_date(dateObject))
    return '';

  var monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul",
    "Aug", "Sep", "Oct", "Nov", "Dec"
  ],
    dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    day = dateObject.getDay(),
    date = dateObject.getDate(),
    monthIndex = dateObject.getMonth(),
    year = dateObject.getFullYear();

  if (endDateObject) {
    var end_day = endDateObject.getDay(),
      end_date = endDateObject.getDate();


  }

  if (type == "day") {
    return dayNames[day] + ' ' + date + ' ' + monthNames[monthIndex] + ' ' + year;
  } else if (type == "week") {
    return dayNames[day] + ' ' + date + ' - ' + dayNames[end_day] + ' ' + end_date + ' ' + monthNames[monthIndex] + ' ' + year;



  } else if (type == "month") {
    return monthNames[monthIndex] + ' ' + year;

  } else if (type == "year") {
    return year;
  } else {

  }

  return dayNames[day] + ' ' + date + ' ' + monthNames[monthIndex] + ' ' + year;
}

export function format_date_full(dateObject, type, endDateObject) {
  if (!is_valid_date(dateObject))
    return '';

  var monthNames = [
    "January", "February", "March", "April", "May", "June", "July",
    "August", "September", "October", "November", "December"
  ],
    dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    day = dateObject.getDay(),
    date = dateObject.getDate(),
    monthIndex = dateObject.getMonth(),
    year = dateObject.getFullYear();

  if (endDateObject) {
    var end_day = endDateObject.getDay(),
      end_date = endDateObject.getDate();


  }

  if (type == "day") {
    return dayNames[day] + ' ' + date + ' ' + monthNames[monthIndex] + ' ' + year;
  } else if (type == "week") {
    return dayNames[day] + ' ' + date + ' - ' + dayNames[end_day] + ' ' + end_date + ' ' + monthNames[monthIndex] + ' ' + year;



  } else if (type == "month") {
    return monthNames[monthIndex] + ' ' + year;

  } else if (type == "year") {
    return year;
  } else {

  }

  return dayNames[day] + ' ' + date + ' ' + monthNames[monthIndex] + ' ' + year;
}

export function format_dates(dates) {
  let start_date = '',
    end_date = '';

  if (typeof dates[0] != "undefined" && dates[0] != null) {
    start_date = format_date(new Date(dates[0]))
  }

  if (typeof dates[1] != "undefined" && dates[1] != null) {
    end_date = format_date(new Date(dates[1]))
  }

  if (start_date.length && end_date.length && start_date != end_date) {
    return start_date + " - " + end_date;
  }

  if (start_date.length) {
    return start_date;
  }

  return 'no date selected';
}


export function is_valid_date(d) {
  return d instanceof Date && !isNaN(d);
}


export function get_days(show_today) {
  const timestamps = [];

  const baseDate = DateTime.now().setZone("Europe/London").startOf("day");

  for (let i = 0; i < 41; i++) {
    const currentDate = baseDate.plus({ days: i });

    let formattedDate = currentDate.toFormat("cccc dd LLLL");

    if (show_today) {
      if (i === 0) formattedDate = "Today";
      if (i === 1 && show_today) formattedDate = "Tomorrow";

    }


    timestamps.push({
      name: formattedDate,
      value: Math.floor(currentDate.toSeconds()), // UNIX timestamp in seconds
    });
  }

  return timestamps;
}


export function getPreviousMonday(date) {
  const dt = DateTime.fromJSDate(date).setZone("Europe/London").startOf("day");

  const daysToSubtract = dt.weekday === 1 ? 0 : dt.weekday - 1;

  return dt.minus({ days: daysToSubtract });
}

export function get_weeks(show_today) {
  let today = DateTime.now().setZone("Europe/London").startOf("day");

  if (today.weekday !== 1) {
    today = getPreviousMonday(today.toJSDate()); // re-use helper
  }

  const timestamps = [];

  for (let i = 0; i < 12; i++) {
    const nextMonday = today.plus({ weeks: i });
    const nextSunday = nextMonday.plus({ days: 6 });

    const formattedStartDate = nextMonday.toFormat("cccc dd LLLL");
    const formattedEndDate = nextSunday.toFormat("cccc dd LLLL");

    timestamps.push({
      name: formattedStartDate + ' - ' + formattedEndDate,
      value: nextMonday.toSeconds(),
    });
  }

  return timestamps;
}

export function get_last_day_of_month(firstDayOfMonth) {
  const lastDay = DateTime
    .fromSeconds(firstDayOfMonth, { zone: "Europe/London" })
    .endOf("month")
    .startOf("day"); // ensures 00:00:00 time

  return lastDay.toSeconds();
}

export function get_months() {
  const today = DateTime.now().setZone("Europe/London").startOf("month");
  const timestamps = [];
  const baseDate = today.startOf("month");
  for (let i = 0; i < 12; i++) {
    const nextMonth = baseDate.plus({ months: i });

    const formattedDate = nextMonth.toFormat("LLLL");

    timestamps.push({
      name: formattedDate,
      value: nextMonth.toSeconds(),
    });
  }

  return timestamps;
}


export function get_last_day_of_year(date) {
  const dt = DateTime.fromSeconds(date, { zone: 'Europe/London' });
  const lastDayOfYear = DateTime.fromObject(
    { year: dt.year, month: 12, day: 31 },
    { zone: 'Europe/London' }
  ).startOf('day');

  return Math.floor(lastDayOfYear.toSeconds());
}


export function get_years() {
  const currentYear = DateTime.now().setZone('Europe/London').year;

  const timestamps = [];

  for (let i = 0; i < 5; i++) {
    const year = currentYear + i;

    const firstDayOfYear = DateTime.local(year, 1, 1, { zone: 'Europe/London' }).startOf('day');

    const formattedDate = firstDayOfYear.toFormat("yyyy");

    timestamps.push({
      name: formattedDate,
      value: Math.floor(firstDayOfYear.toSeconds())
    });
  }

  return timestamps;
}

